import script from "./AppSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSidebar.vue?vue&type=script&setup=true&lang=js"

import "./AppSidebar.vue?vue&type=style&index=0&id=a3ed263e&lang=scss&scoped=true"
import "./AppSidebar.vue?vue&type=style&index=1&id=a3ed263e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3ed263e"]])

export default __exports__